import { useHistory, useLocation } from 'react-router';
import useTracking from '../../../../../../common/src/hooks/tracking/useTracking';
import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import useFlowsBaseUrl from '../../../../hooks/useFlowsBaseUrl';

interface ToggleOverview {
  toggleOverview: () => void;
  hideOverview: () => void;
  showOverview: () => void;
  isOverview: boolean;
}

const OVERVIEW_ROUTE = 'overview';

const useToggleCompanyOverview = (): ToggleOverview => {
  const { pathname, search } = useLocation();
  const history = useHistory();
  const { trackEvent } = useTracking();

  const flowsBaseURL = useFlowsBaseUrl();
  const lastPosition = useFlowsSelector(
    (state) => state.flowsMetaData.lastPosition,
  );

  const hideOverview = () => {
    history.push({ pathname: `${flowsBaseURL}/${lastPosition}`, search });
  };

  const showOverview = () => {
    trackEvent('Show Overview in Company Scan');
    history.push({ pathname: `${flowsBaseURL}/${OVERVIEW_ROUTE}`, search });
  };

  const toggleOverview = () => {
    if (pathname.includes(OVERVIEW_ROUTE)) hideOverview();
    else showOverview();
  };

  const isOverview = pathname.includes(OVERVIEW_ROUTE);

  return {
    toggleOverview,
    hideOverview,
    showOverview,
    isOverview,
  };
};

export default useToggleCompanyOverview;
